const QUESTION_NAMES = {
  SATISFACTION: 'Satisfaction',
  EDITABILITY: 'Editability',
  ALIGNMENT: 'Alignment',
  UP_TO_DATE: 'UpToDate',
  PREDICTIONS: 'Predictions',
};

const ANSWER_OPTIONS = {
  [QUESTION_NAMES.SATISFACTION]: {
    GOOD: 'good',
    SOMEWHAT: 'somewhat',
    BAD: 'bad',
  },
  [QUESTION_NAMES.EDITABILITY]: {
    GOOD: 'good',
    SOMEWHAT: 'somewhat',
    BAD: 'bad',
  },
  [QUESTION_NAMES.ALIGNMENT]: {
    GOOD: 'good',
    SOMEWHAT: 'somewhat',
    BAD: 'bad',
  },
  [QUESTION_NAMES.UP_TO_DATE]: {
    GOOD: 'good',
    SOMEWHAT: 'somewhat',
    BAD: 'bad',
  },
  [QUESTION_NAMES.PREDICTIONS]: {
    GOOD: 'good',
    SOMEWHAT: 'somewhat',
    BAD: 'bad',
  },
};

const QUESTIONS = [
  {
    name: QUESTION_NAMES.SATISFACTION,
    text: 'עד כמה אני מרוצה מהשירות?',
    options: [
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.SATISFACTION].GOOD,
        label: 'מרוצה מאוד',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.SATISFACTION].SOMEWHAT,
        label: 'מרוצה חלקית',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.SATISFACTION].BAD,
        label: 'לא מרוצה',
      },
    ],
  },
  {
    name: QUESTION_NAMES.EDITABILITY,
    text: 'אני יכול לערוך...',
    options: [
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.EDITABILITY].GOOD,
        label: 'את כל מה שצריך',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.EDITABILITY].SOMEWHAT,
        label: 'רק חלק מהדברים שצריך',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.EDITABILITY].BAD,
        label: 'אי-אפשר לערוך את רוב הדברים שצריך',
      },
    ],
  },
  {
    name: QUESTION_NAMES.ALIGNMENT,
    text: 'השירות מציג את החיים הכלכליים שלי…',
    options: [
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.ALIGNMENT].GOOD,
        label: 'בצורה ממש טובה',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.ALIGNMENT].SOMEWHAT,
        label: 'פחות או יותר טובה',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.ALIGNMENT].BAD,
        label: 'השירות לא מייצג אותי',
      },
    ],
  },
  {
    name: QUESTION_NAMES.UP_TO_DATE,
    text: 'המידע בשירות...',
    options: [
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.UP_TO_DATE].GOOD,
        label: 'מעודכן מאוד',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.UP_TO_DATE].SOMEWHAT,
        label: 'פחות או יותר מעודכן, תלוי',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.UP_TO_DATE].BAD,
        label: 'לא מעודכן בכלל',
      },
    ],
  },
  {
    name: QUESTION_NAMES.PREDICTIONS,
    text: 'אפשר להסתמך על התחזית שהשירות מראה לי…',
    options: [
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.PREDICTIONS].GOOD,
        label: 'בצורה ממש טובה',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.PREDICTIONS].SOMEWHAT,
        label: 'פחות או יותר',
      },
      {
        value: ANSWER_OPTIONS[QUESTION_NAMES.PREDICTIONS].BAD,
        label: 'אי-אפשר להסתמך על התחזית',
      },
    ],
  },
];

export default {
  QUESTION_NAMES,
  ANSWER_OPTIONS,
  QUESTIONS,
};



// WEBPACK FOOTER //
// ./src/pages/responsive-pages/authenticated/survey/accuracy-survey/consts/accuracy-questions.js